<label for="file{{elementId}}" class="upload-medium {{customClass}}" [ngClass]="{'done': uploaded}">
    <div class="drop-files" [attr.id]="elementId" [ngClass]="{'is-dragover': isDragOver}">
        <div class="uploader-image"></div>
        <div class="font-mont-book">{{lineA}}</div>
        <div class="font-mont-book">{{lineB}}</div>
    </div>
</label>
<input type="file" id="file{{elementId}}" name="file{{elementId}}" (change)="fileChangeEvent($event)">